<template lang="pug">
    v-stepper(v-model="step" v-if="content")
        v-stepper-items
            v-stepper-content(step="1")
                v-container(grid-list-md)
                    v-layout(wrap)
                        v-flex(lg6 md6 xs12)
                            v-text-field(dense v-model="source" label="No. Rekening Sumber" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="warning") mdi-credit-card-multiple-outline
                        v-flex(lg5 md5 xs12)
                            v-text-field(dense v-model="content.summary.productDescription.toUpperCase()" label="Jenis Transaksi" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-checkbox-marked-outline
                        v-flex(lg6 md6 xs12 v-if="content.note")
                            v-text-field(dense v-model="content.note" label="Berita" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-note-text-outline
                        v-flex(lg5 md5 xs12 v-if="content.customerRef")
                            v-text-field(dense v-model="content.customerRef" label="No. Dokumen" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-file-document-outline
                    v-layout(wrap v-if="content.info.tipeTransaksi == 'TRANSFER'")
                        v-flex(lg6 md6 xs12 v-if="destination")
                            v-text-field(dense v-model="destination" label="No Rekening Tujuan" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="success") mdi-credit-card-multiple-outline
                        v-flex(lg12 md12 xs12 v-if="edit && type")
                            div(class="caption font-weight-bold primary--text") Transaksi Melalui
                                v-radio-group(dense v-model="type" row readonly)
                                    v-radio(label="Transfer" value="TRF_INT" color="primary")
                                    v-radio(v-if="!withoutTrfOnl" label="Transfer Antar Bank" value="TRF_ONL" color="primary")
                                    v-radio(label="SKN" value="SKN" color="primary")
                                    v-radio(label="RTGS" value="RTGS" color="primary")
                    v-layout(wrap)
                        v-flex(lg4 md4 xs12)
                            v-text-field(dense v-model="content.info.noDokumen" label="No. Transaksi" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-checkbox-marked-outline
                        v-flex(lg2 md2 xs12)
                            v-text-field(dense v-model="content.info.kasdaId" label="Kode Pemda" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-checkbox-marked-outline
                        v-flex(lg2 md2 xs12)
                            v-text-field(dense v-model="content.info.tahun" label="Tahun" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-checkbox-marked-outline
                        v-flex(lg3 md3 xs12 v-if="content.info.npwp")
                            v-text-field(dense v-model="content.info.npwp" label="NPWP" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-checkbox-marked-outline
                        v-flex(lg6 md6 xs12 v-if="content.info.namaSubUnit")
                            v-text-field(dense v-model="content.info.namaSubUnit" label="Dinas" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-checkbox-marked-outline
                        v-flex(lg11 md11 xs12)
                            v-text-field(dense v-model="content.info.keteranganDokumen" label="Keterangan" readonly)
                                template(v-slot:prepend)
                                    v-icon(color="primary") mdi-checkbox-marked-outline
                    v-layout(wrap v-if="total && total > 0")
                        v-flex(lg5 md5 xs12)
                            f-decimalbox(v-model="total" label="Nilai Bruto" readonly :template="true")
                    v-layout(wrap v-if="content.info.potongan && content.info.potongan > 0")
                        v-flex(lg5 md5 xs12)
                            f-decimalbox(v-model="content.info.potongan" label="Potongan" readonly :template="true")
                    v-layout(wrap v-if="feeExclude && feeExclude > 0")
                        v-flex(lg5 md5 xs12)
                            f-decimalbox(v-model="feeExclude" label="Admin (Dibebankan ke rekening sumber)" readonly :template="true")
                    v-layout(wrap v-if="feeInclude")
                        v-flex(lg5 md5 xs12)
                            f-decimalbox(v-model="feeInclude" label="Admin" readonly :template="true")
                    v-layout(wrap v-if="amount")
                        v-flex(lg5 md5 xs12)
                            f-decimalbox(v-model="amount" label="Nilai Yang Diterima" readonly :template="true")
                    v-layout(wrap v-if="content.info.listPotongan && content.info.listPotongan.length > 0")
                        v-flex(lg12 md12 xs12)
                            f-kasda-potongan-table(
                                :edit="edit" :reverse="reverse" 
                                :reinquiry="reinquiry" 
                                :data="content.info.listPotongan" 
                                :billingTransaction="billingTransaction" 
                                :billingUpdate="billingUpdate"
                                v-on:reset="emitEvents('reset')"
                                v-on:createBilling="showChangeBillingType($event)"
                                v-on:transaction="doBillingTransaction($event)" 
                                v-on:updateBilling="showChangeBillingType($event)" 
                                v-on:detail="doViewDetail($event)" 
                                v-on:detailPhri="doViewDetailPhri($event)")
                    v-layout(wrap v-if="content.info.listDetail && content.info.listDetail.length > 0")
                        v-flex(lg12 md12 xs12)
                            v-dialog(v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition")
                                template(v-slot:activator="{ on, attrs }")
                                    div(justify-center style="text-align: center" class="ma-2 menu-btn")
                                        v-btn(color="btnprimary white--text" class="mx-1" v-bind="attrs" v-on="on") Detail Transaksi
                                v-card(style="width:100%" elevation="6")
                                    v-toolbar(class="primary--text" dense)
                                        v-toolbar-title(class="title-text") DETAIL TRANSAKSI
                                        v-spacer
                                        div(justify-center style="text-align: center" class="ma-2 menu-btn")
                                            v-btn(class="mx-1" @click="dialog = false") Kembali
                                                v-icon mdi-arrow-left-circle
                                    v-container(grid-list-md)
                                        f-kasda-detail-table(:detail="content.info")
            v-stepper-content(step="2")
                f-billing-form(:billingData="billing" :back="true" :auto="autoInquiry"
                    v-on:billing="showBillingContent($event)" v-on:doBack="doReset" :payTypeData="payTypeData" :content="content")
            v-stepper-content(step="3")
                f-billing-content(:billingData="billing" v-on:back="doReset")
            v-stepper-content(step="4")
                v-container(grid-list-md)
                    v-form(ref="formBilling" id="formBilling" @submit.prevent="doChangeBillnum" lazy-validation)
                        v-layout(wrap)
                            v-flex(lg6 md6 xs12)
                                v-text-field(dense v-model="newBillnum" label="Kode Billing Baru" maxlength="15" :rules="[v => !!v || 'Input kode billing Baru']" required)
                                    template(v-slot:prepend)
                                        v-icon(color="warning") mdi-checkbox-marked-outline
                        div(justify-center style="text-align: center;" class="ma-2 menu-btn")
                            v-btn(class="mx-1" @click="doReset") Kembali
                                v-icon mdi-arrow-left-circle
                            v-btn(color="btnprimary white--text" class="mx-1" type="submit" form="formBilling" :disabled="changeBillingSuccess") Proses
                                v-icon mdi-arrow-right-circle
            v-stepper-content(step="5")
                f-phri-content(:phri="phri" v-on:back="doReset")
            v-stepper-content(step="6")
                v-container(grid-list-md)
                    v-layout(wrap)
                        v-flex(lg6 md6 xs12)
                            v-radio-group(dense v-model="changeBillingType")
                                v-radio(label="Pembuatan Billing Baru" value="CREATE" color="primary")
                                v-radio(label="Masukan Billing Baru" value="CHANGE" color="primary")
                    div(justify-center style="text-align: center;" class="ma-2 menu-btn")
                        v-btn(class="mx-1" @click="doReset") Kembali
                            v-icon mdi-arrow-left-circle
                        v-btn(color="btnprimary white--text" class="mx-1" @click="setFormChangeBilling") Lanjutkan
                            v-icon mdi-arrow-right-circle
</template>
<script>
export default {
    name: "FKasdaTransactionContent",
    props: ["referenceId", "content", "request", "transaction", "edit", 
            "reinquiry", "reverse", "billingTransaction", "billingUpdate","withoutTrfOnl"],
    data() {
        return {
            step: "1",
            editIndex: -1,
            editItem: {},
            billing: null,
            autoInquiry: false,
            phri: null,
            newBillnum: null,
            changeBillingSuccess: false,
            dialog: false,
            changeBillingType: "CHANGE",
            item: null,
            payTypeData: [],
            listData: []
        }
    },
    computed: {
        source() {
            return this.$options.filters.accountformat(this.content.source) + (this.content.sourceName ? (" - " + this.content.sourceName) : "");
        },
        destination() {
            if (this.content.info.tipeTransaksi == 'TRANSFER') {
                return "(" + this.content.info.kodeBankPenerima + ") " + this.$options.filters.accountformat(this.content.info.rekeningPenerima) + " - " + this.content.info.namaPenerima;
            } else {
                return null;
            }
        },
        type() {
            if (this.content.info.tipeTransaksi == 'TRANSFER') {
                return this.request.data.additionalData ? this.request.data.additionalData.productCode : "";
            } else {
                return null;
            }
        },
        amount() {
            if (this.content.info.tipeTransaksi == 'TRANSFER') {
                return this.request.data.nilai;
            } else {
                return this.content.info.nilai;
            }
        },
        feeInclude() {
            if (this.content.info.tipeTransaksi == 'TRANSFER') {
                return this.request.data.biayaInclude;
            } else {
                return null;
            }
        },
        feeExclude() {
            if (this.content.info.tipeTransaksi == 'TRANSFER') {
                return this.request.data.biaya;
            } else {
                return this.content.info.biaya;
            }
        },
        total() {
            if (this.content.info.tipeTransaksi == 'TRANSFER') {
                return this.request.data.total;
            } else {
                return this.content.info.total;
            }
        }
    },
    watch: {
        content(val){
            this.doReset();
        }
    },
    methods: {
        doReset() {
            this.step = "1";
            this.editIndex = -1;
            this.editItem = {};
            this.billing = null;
            this.phri = null;
            this.autoInquiry = false;
            this.newBillnum = null;
            this.changeBillingSuccess = false;
            this.dialog = false;
            this.changeBillingType = "CHANGE";
            this.item = null;
            this.$emit("showButton");
            this.statusPayroll();
            if (this.$refs.formBilling) {
                this.$refs.formBilling.resetValidation();
            }
        },
        emitEvents(event) {
            this.$emit(event);
        },
        setDataMap(item){
          if(item.akun && item.kodeJenisSetoran){
            this.$http.get("/api/parameter/pay-type-tax-by-map-and-paytype/"+item.akun+"/"+item.kodeJenisSetoran).then(success => {
            this.listData = success.data;
              this.payTypeData =this.listData;
          } , err => {
            this.$message.error(err.response.data.message);
          }).finally(() => this.$progress.show(false));
          }
        },
        setBillingData(item) {
            this.editIndex = this.content.info.listPotongan.indexOf(item);
            this.editItem = Object.assign({}, item);
            this.billing = {
                useNpwp: item.additionalData.billing.npwp !== null,
                npwp: item.additionalData.billing.npwp,
                mapTransaction: item.kodeMap,
                jenisSetor: item.additionalData.billing.kodeJenisSetoran,
                nama: item.additionalData.billing.namaWajibPajak,
                alamat: item.additionalData.billing.alamatWajibPajak,
                kota: item.additionalData.billing.kotaWajibPajak,
                periode1: item.additionalData.billing.periode1,
                periode2: item.additionalData.billing.periode2,
                tahun: item.additionalData.billing.tahun,
                noKetetapan: item.additionalData.billing.noSk || '',
                npwpSetor: item.additionalData.billing.npwpSetor,
                kpp: item.additionalData.billing.kpp,
                nop: item.additionalData.billing.nop || '',
                billNumber: item.idBilling,
                expiredDate: item.expiredDate,
                idWajibPajak: item.additionalData.billing.idWajibPajak,
                amount: item.nilai,
                namaMap: item.namaMap,
                namaJenisSetor: item.additionalData.billing.namaJenisSetoran,
                namaSetor: item.additionalData.billing.namaSetor,
                noFaktur: item.additionalData.billing.noFaktur||'',
                uraian: item.additionalData.billing.uraian||'',
                kodePemda: item.kasdaId,
                kdSkpd: this.content.info.kodeSkpd,
                noSpm: this.content.info.noSpm,
                ntpn: item.additionalData.billing.ntpn,
                status: item.status,
                errorMessage: item.keteranganError,
                jumlahDetail: item.additionalData.billing.detail,
                additionalData: {
                    map: {
                        mapId: item.kodeMap,
                        description: item.namaMap
                    },
                    payType: {
                        payType: item.additionalData.billing.kodeJenisSetoran,
                        description: item.additionalData.billing.namaJenisSetoran
                    }
                }
            }
        },
        doViewDetail(item){
            this.setBillingData(item);
            this.$emit("hideButton");
            this.step = "3";
        },
        doViewDetailPhri(item){
            this.editIndex = this.content.info.listPotongan.indexOf(item);
            this.editItem = Object.assign({}, item);
            this.phri = {
                noSts: item.additionalData.inquiryResponse.info.noSts,
                account: item.additionalData.inquiryResponse.info.account,
                customerName: item.additionalData.inquiryResponse.info.customerName,
                customerAddress: item.additionalData.inquiryResponse.info.customerAddress,
                handphone: item.additionalData.inquiryResponse.info.handphone,
                nop: item.additionalData.inquiryResponse.info.nop,
                anggaran: item.additionalData.inquiryResponse.info.anggaran,
                amount: item.additionalData.inquiryResponse.summary.amount,
            }
            this.$emit("hideButton");
            this.step = "5";
        },
        showChangeBilling(item){
            this.editIndex = this.content.info.listPotongan.indexOf(item);
            this.editItem = Object.assign({}, item);
            this.newBillnum = null;
            if (this.$refs.formBilling) {
                this.$refs.formBilling.resetValidation();
            }
            this.$emit("hideButton");
            this.step = "4";
        },
        showBillingForm(item){
            this.autoInquiry = true;
            this.setDataMap(item.additionalData.billing);
            this.setBillingData(item);
            this.$emit("hideButton");
            this.step = "2";
        },
        showBillingContent(value){
            this.billing = value;
            if (this.billing) {
                this.editItem.additionalData.billing.idBilling = this.billing.billNumber;
                this.editItem.expiredDate = this.billing.expiredDate;
                this.editItem.additionalData.billing.kodeJenisSetoran = this.billing.jenisSetor;
                this.editItem.additionalData.billing.namaJenisSetoran = this.billing.namaJenisSetor;
                this.editItem.idBilling = this.billing.billNumber;
                this.editItem.additionalData.billing.nop = this.billing.nop;
                this.editItem.additionalData.billing.npwpSetor = this.billing.npwpSetor;
                this.editItem.additionalData.billing.noKetetapan = this.billing.noKetetapan;
                this.editItem.additionalData.billing.namaSetor = this.billing.namaSetor;
                this.editItem.additionalData.billing.idWajibPajak = this.billing.idWajibPajak;
                this.editItem.additionalData.billing.namaWajibPajak = this.billing.nama;
                this.editItem.additionalData.billing.alamatWajibPajak = this.billing.alamat;
                this.editItem.additionalData.billing.kotaWajibPajak = this.billing.kota;
                this.editItem.additionalData.billing.noFaktur = this.billing.noFaktur;
                this.editItem.additionalData.billing.kodePemda = this.billing.kodePemda;
                this.editItem.additionalData.billing.uraian = this.billing.uraian;
                this.editItem.additionalData.billing.tahun = this.billing.tahun;
                let request = {
                    kasdaId: this.content.info.kasdaId,
                    tahun: this.content.info.tahun,
                    noDokumen: this.content.info.noDokumen,
                    jenisDokumen: this.content.info.jenisDokumen,
                    rekeningSumber: this.content.info.rekeningSumber,
                    idBilling: this.editItem.idBilling,
                    expiredDate: this.editItem.expiredDate,
                    potongan: this.editItem
                }
                this.doUpdateBilling(request);
            }
        },
        doUpdateBilling(request){
            this.$progress.show(true);
            this.$http.put("api/agg-kasda/billing", request)
                .then(success => {
                    Object.assign(this.content.info.listPotongan[this.editIndex], success.data);
                    this.updateDataResponse();
                    this.step = "3";
                    this.$message.success("Kode Billing berhasil di ubah");
                }, err => {
                    this.$message.error(err.response.data.message);
                }).finally(() => this.$progress.show(false));
        },
        doChangeBillnum(){
            if (this.$refs.formBilling.validate()) {
                this.setBillingData(this.item);
                let request = {
                    kasdaId: this.content.info.kasdaId,
                    tahun: this.content.info.tahun,
                    noDokumen: this.content.info.noDokumen,
                    jenisDokumen: this.content.info.jenisDokumen,
                    rekeningSumber: this.content.info.rekeningSumber,
                    idBilling: this.newBillnum,
                    potongan: this.editItem
                }
                this.doUpdateBilling(request);
            }
        },
        doBillingTransaction(item){
            this.editIndex = this.content.info.listPotongan.indexOf(item);
            this.editItem = Object.assign({}, item);
            let request = {
                kasdaId: this.content.info.kasdaId,
                tahun: this.content.info.tahun,
                noDokumen: this.content.info.noDokumen,
                jenisDokumen: this.content.info.jenisDokumen,
                rekeningSumber: this.content.info.rekeningSumber,
                idBilling: this.editItem.idBilling,
                potongan: this.editItem
            }
            this.$progress.show(true);
            this.$http.post("api/agg-kasda/billing", request)
                .then(success => {
                    let response = success.data;
                    if (response.status == 'BERHASIL') {
                        this.$message.success("Data berhasil di transaksikan");
                    } else if (response.status == 'REINQUIRY') {
                        this.$message.info("Data berhasil di transaksikan, namun belum mendapatakan ntpn");
                        this.referenceId=this.content.referenceId?this.content.referenceId:null;
                    } else {
                        this.$message.error(response.message);    
                    }
                    Object.assign(this.content.info.listPotongan[this.editIndex], response);
                    this.updateDataResponse();
                }, err => {
                    this.$message.error(err.response.data.message);
                }).finally(() => this.$progress.show(false));
        },
        updateDataResponse(){
            if (this.referenceId) {
                this.$http.put("api/transaction/response", {
                    referenceId: this.referenceId || '',
                    productId: this.content.summary.productCode,
                    dataResponse: this.content
                }).then(success => {
                    this.$emit("dataResponse", this.content);
                }, err => {
                    this.$message.error(err.response.data.message);
                });
            }
        },
        statusPayroll() {
            if (this.content && this.content.info) {
                if (this.content.info.productId.includes("PAYROLL")) {
                    if (this.content.info.additionalData && this.content.info.additionalData.gaji) {
                        if (this.content.info.additionalData.gaji.payrollId) {
                            this.$progress.show(true);
                            this.$http.post("api/agg-kasda/payroll-status", this.content.info.additionalData.gaji)
                            .then(success => {
                                this.content.info.additionalData.gaji = success.data;
                            }, err => {}).finally(() => this.$progress.show(false));
                        }
                    }
                }
            }
        },
        showChangeBillingType(item) {
            this.item = item;
            if(this.edit) {
              this.showBillingForm(this.item);
            }else{
              // if (this.content.info.jenisDokumen == 'SP2D') {
                this.changeBillingType = "CHANGE";
                this.$emit("hideButton");
                this.step = "6";
              // } else {
              //   this.showChangeBilling(this.item);
              // }
            }
        },
        setFormChangeBilling() {
            if (this.item) {
                if (this.changeBillingType == 'CHANGE') {
                    this.showChangeBilling(this.item);
                }else{
                    this.showBillingForm(this.item);
                }
            }else {
                this.$message.error("Tidak ada item yang di pilih");
            }
        }
    },
}
</script>